import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useAuth } from './auth-context.js';

/**
 * Landing spot for the OAuth redirect.
 *
 * The Supabase client is configured with `detectSessionInUrl`, so it exchanges
 * the code on its own; this page only waits for that to settle and forwards
 * the error when the account is not on the allowlist.
 */
export function AuthCallbackPage() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const [error] = useState(() => readErrorFromUrl());

  useEffect(() => {
    if (error) {
      const params = new URLSearchParams({ error_description: error });
      navigate(`/login?${params.toString()}`, { replace: true });
    }
  }, [error, navigate]);

  if (error) return null;
  if (status === 'authenticated') return <Navigate to="/" replace />;
  if (status === 'anonymous') return <Navigate to="/login" replace />;

  return (
    <div className="page-state" role="status" aria-live="polite">
      Bejelentkezés…
    </div>
  );
}

/** Supabase reports OAuth failures in the query string or the hash fragment. */
function readErrorFromUrl(): string | null {
  const query = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  return (
    query.get('error_description') ??
    query.get('error') ??
    hash.get('error_description') ??
    hash.get('error')
  );
}
